import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { MessageDialog } from '../../components/message-dialog/messageDialog';
import { Location } from '@angular/common';
import { SessionHelper } from '../../core/helper/sessionHelper';
import { RecurringJobService } from '../../core/services/hangfire/recurringJobService.service';
import { RecurringJob } from '../../core/models/hangfireJobs/recurringJob.model';
import cronstrue from 'cronstrue/i18n';
import * as moment from 'moment';
import 'moment/locale/es'  // without this line it didn't work
import { JobLog } from '../../core/models/hangfireJobs/JobLog.model';
import { Job } from '../../core/models/hangfireJobs/job.model';
import { JobLogLine } from '../../core/models/hangfireJobs/jobLogLine.model';

moment.locale('es');

@Component({
  selector: 'app-proceso-detail',
  templateUrl: './proceso-detail.component.html',
  styleUrls: ['./proceso-detail.component.scss'],
  providers: [RecurringJobService]
})
export class ProcesoDetailComponent implements OnInit {

  model: RecurringJob;
  logs: JobLog;
  jobId: string;

  humanfriendlyCronExp: string;
  hora: number = 0;
  minutos: number = 0;

  constructor(
    private _route: ActivatedRoute,
    private _modelRecurringJobService: RecurringJobService,
    protected _messageDialog: MessageDialog,
    _router: Router,
    _location: Location,
    _session: SessionHelper) {

  }

  updateCronExpression(e, horas: boolean) {

    if (horas)
      this.hora = e.target.value;
    else
      this.minutos = e.target.value;

    let cronExpresion = "";

    const expresionMinutos = this.minutos && this.minutos > 0 ? "*/" + this.minutos : "0";
    const expresionHoras = this.hora && this.hora > 1 ? "*/" + this.hora : "*";

    cronExpresion = `${expresionMinutos} ${expresionHoras} * * *`

    this.model.Cron = cronExpresion;
    this.parseCronExpression(this.model.Cron);
  }

  updateRecurringJob(){
    this._modelRecurringJobService.updateCronInterval(this.model.Id, this.model.Cron).subscribe(
      res => this._messageDialog.ShowMessage("La frecuencia de ejecución ha sido actualizada corretamente","Atención"),
      err => this._messageDialog.ShowAlert("No se ha podido actualizar la frecuencia de ejecución","Error"));
  }

  getHourAndMinutesFromCronExpression(cron: string) {
    if (cron) {
      try {
        const stringArray = cron.split(" ");
        this.hora = 0;

        if(stringArray && stringArray[0].indexOf("/") > 0){
          this.minutos =  Number.parseInt(stringArray[0].split("/")[1]);
        }else{
          this.minutos = stringArray && stringArray[0] !== "*" ? Number.parseInt(stringArray[0]) : 0;
        }

        if(stringArray.length > 1) {
          const horaArray = stringArray[1].split("/");
          this.hora =  horaArray && horaArray.length > 1 ? Number.parseInt(horaArray[1]) : 0;
        }

      } catch (error) {
        console.error(error);
      }
    }
  }

  afterModelLoad(): void {
    this.getHourAndMinutesFromCronExpression(this.model.Cron);
    this.parseCronExpression(this.model.Cron);


    if (this.jobId) {
      this._modelRecurringJobService.getLog(this.jobId).subscribe(
        response => {
          this.logs = new JobLog();
          this.logs = Object.assign(this.logs, response);
          if (this.logs && this.logs.Active) {
            window.setTimeout(() => {
              this.afterModelLoad();
            }, 10000);
          }
        },
        error => {
          console.error(error);
        }
      );
    }
  }

  getMomentExpression(log: JobLogLine) {
    return moment(log.Timestamp).diff(this.model.LastExecution);
  }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this._route.params
      .subscribe(
        (params: Params) => {
          const id = params['id'];
          if (id) {
            this._modelRecurringJobService.getModel(id).subscribe(
              (response: RecurringJob) => {
                this.model= Object.assign(new RecurringJob(), response);

                if (this.model) {
                  this.afterModelLoad();
                }
              },
              err => {
                console.error(err);
              }
            )
          }
        }
      );
  }

  onSelectedJobChange(job: Job) {
    this.jobId = job.JobId;
    this.afterModelLoad();
  }

  parseDateToMoment(date: Date) {
    const value = moment(date);
    value.locale("es");
    return value.format("LLLL")
  }

  parseCronExpression(cron: string) {
    this.humanfriendlyCronExp = cronstrue.toString(cron, { locale: "es" });
  }

  toHumanDuration(jobProcessingStartedAt: Date, duration: Date, displaySign: boolean = true): string {
    let humanDuration = '';

    if (!duration) return humanDuration;

    const daysDiff = moment(duration).diff(jobProcessingStartedAt, 'days');
    const minutesDiff = moment(duration).diff(jobProcessingStartedAt, 'minutes');
    const hoursDiff = moment(duration).diff(jobProcessingStartedAt, 'hours');
    const secondsDiff = moment(duration).diff(jobProcessingStartedAt, 'seconds');
    const milisecondsDiff = moment(duration).diff(jobProcessingStartedAt, 'milliseconds');

    if (displaySign) {
      humanDuration = milisecondsDiff < 0 ? "-" : "+";
    }

    if (daysDiff > 0) {
      humanDuration = `${humanDuration}${daysDiff}d`;
    }

    if (hoursDiff > 0) {
      humanDuration = `${humanDuration}${hoursDiff}h`;
    }

    if (minutesDiff > 0) {
      humanDuration = `${humanDuration}${minutesDiff}m`;
    }

    if (hoursDiff < 1) {
      if (secondsDiff > 0) {
        // console.log(secondsDiff / 60);
        // console.log( Math.floor(secondsDiff / 60));
        const seconds = Math.floor((secondsDiff / 60 - Math.floor(secondsDiff / 60)) * 60)
        humanDuration = `${humanDuration} ${seconds}`;
        // if (milisecondsDiff > 0)
        // {
        //   humanDuration =`${humanDuration}.${milisecondsDiff.toString().padStart(3,"0")}`;
        // }

        humanDuration = `${humanDuration}s`;
      }
      else {
        if (milisecondsDiff > 0) {
          humanDuration = `${humanDuration}${milisecondsDiff}ms`;
        }
      }
    }



    if (humanDuration.length <= 1) {
      humanDuration = `${humanDuration} <1ms `;

    }

    return humanDuration;
  }

}
